:host {
  --ds-icon-color: currentcolor;
  --ds-icon-width: #{rem(1)}; //16px
  --ds-icon-height: var(--ds-icon-width);
  display: flex;
  align-items: center;
}

:host(.icon--big) {
  --ds-icon-width: #{rem(1.25)}; //20px
}

:host(.icon--small) {
  --ds-icon-width: #{rem(.5)}; //8px
}

svg {
  width: 100%;
  height: 100%;
}

.icon__inner {
  display: inline-flex;
  box-sizing: content-box;
  width: var(--ds-icon-width);
  height: var(--ds-icon-height);
  color: var(--ds-icon-color);

  &--rtl {
    transform: scaleX(-1);
  }
}
